import { createReducer } from '@reduxjs/toolkit'
import ActionTypes from '@constants/action_types.js'
import { exists } from '@utils/functions.js'

export const initialState = []

export const tag = createReducer(initialState, builder => {
  builder.addCase(ActionTypes.RECEIVE_TAGS, (state, action) => addTags(state, action))
})

export default tag

function addTags(state, action) {
  const { payload: tags } = action
  if (exists(tags)) {
    state = state.concat(tags)
  }
  return state
}
